import { BarList } from "@tremor/react";
import ExpandableChartCard from "../../../../shared/charts/ExpandableChartCard";

/**
 * codex.md — Pipeline by stage. Inline shows top 5 stages;
 * expand reveals the rest + sums.
 */
const INLINE_LIMIT = 5;

export default function PipelineChart({ data, canSee }) {
  if (!canSee) return null;
  const total = Array.isArray(data) ? data.length : 0;
  return (
    <ExpandableChartCard
      title="Pipeline — value by stage"
      subtitle="Sum of dealValue grouped by Scoping stage"
      renderChart={({ expanded }) => {
        if (!Array.isArray(data) || total === 0) {
          return (
            <div style={{ textAlign: "center", padding: "32px 0", color: "#6889b4", fontSize: 12 }}>
              No scoping items with deal values.
            </div>
          );
        }
        const visible = expanded ? data : data.slice(0, INLINE_LIMIT);
        const hiddenCount = total - visible.length;
        return (
          <>
            <BarList
              data={visible}
              className="mt-2"
              color="blue"
              valueFormatter={(v) => `${v.toLocaleString()} kr`}
            />
            {!expanded && hiddenCount > 0 && (
              <div style={{ marginTop: 10, fontSize: 11, color: "#6889b4" }}>
                + {hiddenCount} more stage{hiddenCount === 1 ? "" : "s"} — click ⛶ Expand.
              </div>
            )}
          </>
        );
      }}
    />
  );
}
